import { useAppSelector } from "@/store/hooks";
import { selectPromptList } from "@/store/qas/qasPromptSlice";
import useTranslate from "@/hooks/useTranslate";
import H3 from "@/ui/H3/H3";
import IconWithPopupInfo from "../IconWithPopupInfo/IconWithPopupInfo";
import { IRequestTemplatePopupInfoProps } from "./RequestTemplatePopupInfo.props";
import styles from "./RequestTemplatePopupInfo.module.scss";

const RequestTemplatePopupInfo = ({ inputSelectedPrompt }: IRequestTemplatePopupInfoProps): JSX.Element => {
	const promptList = useAppSelector(selectPromptList); // store - список промптов

	const translate = useTranslate(); // hook для перевода текста

	return (
		<>
			{/* кнопка информации о шаблоне запроса */}
			{inputSelectedPrompt?.id && (
				<IconWithPopupInfo>
					<div className={styles.template}>
						<H3>{translate("title_requestTemplate")}</H3>
						<div className={styles.rule}>{promptList.data?.find((promptItem) => promptItem.id === inputSelectedPrompt?.id)?.prompt}</div>
						{promptList.data?.find((promptItem) => promptItem.id === inputSelectedPrompt?.id)?.postprompt && (
							<>
								<H3>{translate("title_templateForReducingResponseIntoSingleOne")}</H3>
								<div className={styles.rule}>{promptList.data?.find((promptItem) => promptItem.id === inputSelectedPrompt?.id)?.postprompt}</div>
							</>
						)}
					</div>
				</IconWithPopupInfo>
			)}
		</>
	);
};

export default RequestTemplatePopupInfo;
